const LOTTIE_CDN = 'https://cdn.ganttpro.com/statics';

const hasModal = [
  { name: 'portfolio_view', lottie: `${LOTTIE_CDN}/animation/Portfolios.json` },
  { name: 'overdue_tasks', lottie: `${LOTTIE_CDN}/animation/Overdue-task.json` },
  { name: 'cascade_sorting', lottie: `${LOTTIE_CDN}/animation/Cascade-sorting.json` },
  { name: 'saving_filters', lottie: `${LOTTIE_CDN}/animation/Filter.json` },
  { name: 'bulk_change', lottie: `${LOTTIE_CDN}/animation/Bulk-change.json` },
  { name: 'saving_project_templates', lottie: `${LOTTIE_CDN}/animation/Saving-project-templates.json` },
  { name: 'time_tracking', lottie: `${LOTTIE_CDN}/animation/Time-tracking.json` },
  { name: 'gantt_view', lottie: `${LOTTIE_CDN}/animation/GanttChart.json` },
  { name: 'board_view', lottie: `${LOTTIE_CDN}/animation/Board.json` },
  { name: 'workload_view', lottie: `${LOTTIE_CDN}/animation/Workload.json` },
  { name: 'auto_scheduling', lottie: `${LOTTIE_CDN}/animation/Autoscheduling.json` },
  { name: 'baseline', lottie: `${LOTTIE_CDN}/animation/Baseline.json` },
  { name: 'critical_path', lottie: `${LOTTIE_CDN}/animation/Critical-path.json` },
  { name: 'dependencies', lottie: `${LOTTIE_CDN}/animation/Dependences.json` },
  { name: 'milestones', lottie: `${LOTTIE_CDN}/animation/Milestones.json` },
  { name: 'project_calendar', lottie: `${LOTTIE_CDN}/animation/Project-calendar.json` },
  { name: 'virtual_resources', lottie: `${LOTTIE_CDN}/animation/Virtual-resources.json` },
  { name: 'costs', lottie: `${LOTTIE_CDN}/animation/Budget-planning.json` },
  { name: 'import', lottie: `${LOTTIE_CDN}/animation/Import.json` },
  { name: 'export', lottie: `${LOTTIE_CDN}/animation/Export.json` },
  { name: 'calendar_view', lottie: `${LOTTIE_CDN}/animation/Calendar.json` },
  { name: 'dashboard_view', lottie: `${LOTTIE_CDN}/animation/Dashboard.json` },
  { name: 'deadlines', lottie: `${LOTTIE_CDN}/animation/Deadline.json` },
  { name: 'reports', lottie: `${LOTTIE_CDN}/animation/Reports.json` },
  { name: 'project_calendar_exceptions', lottie: `${LOTTIE_CDN}/animation/Calendar-exceptions.json` },
  { name: 'personal_calendar', lottie: `${LOTTIE_CDN}/animation/Resource-calendars.json` },
  { name: 'public_url', lottie: `${LOTTIE_CDN}/animation/Shared-private-link.json` },
  { name: 'mobile_app', lottie: `${LOTTIE_CDN}/animation/Mobile-app.json` },
  { name: 'custom_fields', lottie: `${LOTTIE_CDN}/animation/Custom-fields.json` },
  { name: 'custom_permissions', lottie: `${LOTTIE_CDN}/animation/Custom-roles-&-rights.json` },
  { name: 'attachments_comments', lottie: `${LOTTIE_CDN}/animation/Comment-&-attachments.json` },
  { name: 'history', lottie: `${LOTTIE_CDN}/animation/History.json` },
];

const addModalProp = (name, feature) => {
  const objectModal = hasModal.find(modal => modal.name === name);

  if (!objectModal) return;

  feature.modal = true;
  feature.lottie = objectModal.lottie;
};

export default {
  prepareGroupFeatures(categoryName, features) {
    let sorted = [];

    switch (categoryName) {
      case 'project_views_features_category': {
        const projectViews = [
          'gantt_view',
          'board_view',
          'list_view',
          'calendar_view',
          'dashboard_view',
          'portfolio_view',
          'workload_view',
        ];

        projectViews.forEach(name => {
          const isFeature = features.find(f => f.name === name);

          addModalProp(name, isFeature);
          if (isFeature) sorted.push(isFeature);
        });

        break;
      }

      case 'project_planing_features_category': {
        const projectPlanning = [
          'auto_scheduling',
          'baseline',
          'critical_path',
          'dependencies',
          'deadlines',
          'milestones',
          'overdue_tasks',
          'cascade_sorting',
          'saving_filters',
          'bulk_change',
          'saving_project_templates',
          'reports',
        ];

        projectPlanning.forEach(name => {
          const isFeature = features.find(f => f.name === name);

          addModalProp(name, isFeature);
          if (isFeature) sorted.push(isFeature);
        });

        break;
      }

      case 'team_collaboration_features_category':
        sorted = features.filter(f => f.name !== 'permissions');
        sorted.forEach(f => addModalProp(f.name, f));

        break;

      case 'resource_management_features_category': {
        const resourceManagement = [
          'project_calendar',
          'project_calendar_exceptions',
          'personal_calendar',
          'resource_types',
          'workload',
          'costs',
          'estimation',
          'time_tracking',
          'virtual_resources',
        ];

        resourceManagement.forEach(name => {
          const isFeature = features.find(f => f.name === name);

          addModalProp(name, isFeature);
          if (isFeature) sorted.push(isFeature);
        });

        break;
      }

      case 'api_integrations_features_category': {
        const apiIntegrations = [
          'slack',
          'one_drive_integration',
          'google_drive_integration',
          'ms_teams',
          'jira_cloud',
          'sso',
          'api',
        ];

        apiIntegrations.forEach(name => {
          const isFeature = features.find(f => f.name === name);

          addModalProp(name, isFeature);
          if (isFeature) sorted.push(isFeature);
        });

        break;
      }

      case 'security_features_category': {
        const securityFeatures = ['two_factor_auth', 'saml_sso'];

        securityFeatures.forEach(name => {
          const isFeature = features.find(f => f.name === name);

          addModalProp(name, isFeature);
          if (isFeature) sorted.push(isFeature);
        });

        break;
      }

      case 'support_features_category': {
        const supportFeatures = ['live_chat', 'email_support', 'tutorials', 'cs_manager', 'onboarding_assistance'];

        supportFeatures.forEach(name => {
          const isFeature = features.find(f => f.name === name);

          addModalProp(name, isFeature);
          if (isFeature) sorted.push(isFeature);
        });

        break;
      }

      case 'etc_features_category': {
        const etcFeatures = ['import', 'export', 'public_url', 'mobile_app'];

        etcFeatures.forEach(name => {
          const isFeature = features.find(f => f.name === name);

          addModalProp(name, isFeature);
          if (isFeature) sorted.push(isFeature);
        });

        break;
      }

      default:
        sorted = features;
    }

    return sorted;
  },
  getTableFeatures() {
    const paymentFeatures = user.paymentFeatures;
    const featuresData = { ...paymentFeatures };
    const tableConfig = [];
    const ETC_CATEGORY = 'etc_features_category';
    const SUPPORT_CATEGORY = 'support_features_category';

    featuresData.custom_permissions.category_locale = 'team_collaboration_features_category';
    featuresData.saml_sso.category_locale = 'security_features_category';
    featuresData.workload_view.id = featuresData.workload.id;

    const groupByFeatures = _.groupBy(_.values(featuresData), 'category_locale');
    const ETC_FEATURES = this.prepareGroupFeatures(ETC_CATEGORY, groupByFeatures[ETC_CATEGORY]);
    const SUPPORT_FEATURES = this.prepareGroupFeatures(SUPPORT_CATEGORY, groupByFeatures[SUPPORT_CATEGORY]);

    for (const key in groupByFeatures) {
      if (key === ETC_CATEGORY || key === SUPPORT_CATEGORY) {
        continue;
      }

      if (key !== 'null') {
        const features = this.prepareGroupFeatures(key, groupByFeatures[key]);

        tableConfig.push({
          title: key,
          features,
        });
      }
    }

    tableConfig.push({
      title: SUPPORT_CATEGORY,
      features: SUPPORT_FEATURES,
    });

    tableConfig.push({
      title: ETC_CATEGORY,
      features: ETC_FEATURES,
    });

    return tableConfig;
  },
};

export function getPricePerUser(priceData, userCount) {
  return priceData.reduce((acc, item) => {
    if (userCount >= item.users) {
      acc = item.price;
    }

    return acc;
  }, 0);
}
